module.exports = function() {
  return new Worker(__webpack_public_path__ + "9d30abdba18fa2575ea5.worker.js");
};